"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const createSvgIcon_1 = __importDefault(require("../utils/createSvgIcon"));
exports.default = (0, createSvgIcon_1.default)(react_1.default.createElement("g", null,
    react_1.default.createElement("path", { d: "M11.9999 9.0005a.75.75 0 0 0-.75.75v5.25a.75.75 0 0 0 1.5 0v-5.25a.75.75 0 0 0-.75-.75ZM12.7499 18.0005a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z" }),
    react_1.default.createElement("path", { fillRule: "evenodd", d: "M21.952 19.5007 13.2991 4.5024c-.5772-1.0006-2.0213-1.0006-2.5985 0l-8.653 14.9983c-.5768 1 .1449 2.2496 1.2994 2.2496h17.3057c1.1545 0 1.8762-1.2496 1.2993-2.2496ZM11.9998 5.252l8.6529 14.9983H3.347L11.9998 5.252Z", clipRule: "evenodd" })), 'ErrorIcon');
